import React from 'react'

import classes from './BackButton.module.scss'

type Props = {
  text: string
  onClick?: (e: React.MouseEvent) => void
}
export const BackButton = ({ text, onClick }: Props): JSX.Element => {
  return (
    <button
      className={classes.back}
      onMouseDown={e => (onClick ? onClick(e) : null)}
    >
      <i className="icon-arrow-left"></i>
      {text}
    </button>
  )
}
